import "./list.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import VitalParameter from "../../components/patient-timeline/vital-parameter"

const VitalParameterContainer = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <VitalParameter />
      </div>
    </div>
  )
}

export default VitalParameterContainer